import { ptBR as m } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/pt-BR.js";
import { ja as i } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/ja.js";
import { it as f } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/it.js";
import { fr as e } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/fr.js";
import { es as p } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/es.js";
import { de as n } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/de.js";
import { enUS as t } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/en-US.js";
const o = {
  "en-us": t,
  "de-de": n,
  "es-mx": p,
  "fr-fr": e,
  "it-it": f,
  "ja-jp": i,
  "pt-br": m
};
function x(r) {
  return r in o ? o[r] : t;
}
export {
  x as getLocaleFromCode
};
